// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"38":"b5b8340a","111":"34ffa2b9","414":"dd274475","816":"52ee2732"}[chunkId] + ".css";
};